var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66732 27.3337C2.75065 27.3337 1.96621 27.0075 1.31398 26.3553C0.661762 25.7031 0.335095 24.9181 0.333984 24.0003V4.00033C0.333984 3.08366 0.660651 2.29921 1.31398 1.64699C1.96732 0.99477 2.75176 0.668103 3.66732 0.666992H30.334C31.2507 0.666992 32.0357 0.993659 32.689 1.64699C33.3423 2.30033 33.6684 3.08477 33.6673 4.00033V24.0003C33.6673 24.917 33.3412 25.702 32.689 26.3553C32.0368 27.0087 31.2518 27.3348 30.334 27.3337H3.66732ZM17.0007 15.667L30.334 7.33366V4.00033L17.0007 12.3337L3.66732 4.00033V7.33366L17.0007 15.667Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.83378b2a94bcab2f74b5571d06ff7d87.svg";
export { ForwardRef as ReactComponent };